import { Box, CssBaseline, ThemeProvider } from "@mui/material"
import { Outlet } from "react-router-dom"
import { TopNavBar } from "../components/TopNavBar/TopNavBar.Component"
import { beOliveTheme } from "../themes/beOliveTheme";
import { useState } from "react";
import { oliveTheme } from "../themes/oliveTheme";
import { sepiaVintageTheme } from "../themes/sepiaVintageTheme";
import { tealDominantTheme } from "../themes/tealDominantTheme";
import { tealTheme } from "../themes/tealTheme";

export const MainPage = () => {
    const [currentTheme, setCurrentTheme] = useState("olive");

    const themes: Record<string, any> = {
        olive: oliveTheme,
        teal: tealTheme,
        sepiaVintage: sepiaVintageTheme,
        tealDominant: tealDominantTheme,
        beOlive: beOliveTheme,
    };

    // const theme = oliveTheme;
    // const theme = tealTheme;
    // const theme = sepiaVintageTheme;
    // const theme = tealDominantTheme;
    const theme = themes[currentTheme];
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Box
                sx={{
                    padding: 2,
                    mb: 2,
                    margin: 0,
                    height: '100dvh',
                }}
            >
                {/* <TutorialOverlay flowKey="chooseGuardian" /> */}
                <TopNavBar onThemeChange={setCurrentTheme} />
                
                <Box sx={{ height: 16 }} />
                <Outlet />
            </Box>
        </ThemeProvider >
    )
}